import { render, staticRenderFns } from "./areadialog.vue?vue&type=template&id=7d974aa4&scoped=true"
import script from "./areadialog.vue?vue&type=script&lang=js"
export * from "./areadialog.vue?vue&type=script&lang=js"
import style0 from "./areadialog.vue?vue&type=style&index=0&id=7d974aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d974aa4",
  null
  
)

export default component.exports